import { all, call, put, takeLatest } from 'redux-saga/effects';
import { get } from '../../../services/api';
import {
  contentsEnpoint,
  topicContentEndpoint
} from '../../../services/endpoint';
import { setCommunities } from '../../actions/community/communityActions';
import {
  fetchContentFailure,
  fetchContentSuccess,
  FETCH_CONTENT_REQUEST
} from '../../actions/content/contentActions';
import { normaliseCommunities } from '../../utils/utils';

export function* fetchContent(action) {
  const { contentId, topicId } = action.payload;
  try {
    let response = {};
    // Viewing content via a topic will not work for users who are not part of the community
    // the content sits in. In these scenarios we recevie a topic id (from the gon) which if received we should
    // make a content request using a different endpoint than we otherwise would. topics_content endpoint essentially bypassess the
    // community restriction /content imposses.
    if (topicId) {
      const params = {
        content_id: contentId,
        topic_id: topicId
      };
      response = yield call(get, topicContentEndpoint(), { params });
    } else {
      response = yield call(get, contentsEnpoint(contentId));
    }
    if (response) {
      const { communities } = response;
      // Simple normaliser for communities so that we can reuse the same code for when
      // we display the community name on a comment.
      const normalisedCommunities = normaliseCommunities(communities);
      yield put(setCommunities(normalisedCommunities));
      yield put(fetchContentSuccess(response));
    } else {
      yield put(fetchContentFailure(response));
    }
  } catch (err) {
    const { response } = err;
    yield put(fetchContentFailure(response));
  }
}

export default function* root() {
  yield all([yield takeLatest(FETCH_CONTENT_REQUEST, fetchContent)]);
}
